import React, { useState, useEffect } from 'react';
import { api } from '../../api';

const TarifasSection = () => {
  const [tarifas,       setTarifas]       = useState([]);
  const [loading,       setLoading]       = useState(true);
  const [editingTarifa, setEditingTarifa] = useState(null);
  const [showNewForm,   setShowNewForm]   = useState(false);
  const [lastUpdate,    setLastUpdate]    = useState(null);
  const [newTarifa,     setNewTarifa]     = useState({
    categoria: '', bajadabandera: 0, ficha: 0,
    bajadabanderanoct: 0, fichanoct: 0,
    horarioNocturnoInicio: '22:00', horarioNocturnoFin: '05:00'
  });

  useEffect(() => { loadTarifas(); }, []);

  const loadTarifas = async () => {
    try {
      setLoading(true);
      const data = await api.get('/tarifas/admin');
      setTarifas(Array.isArray(data) ? data : data.tarifas || []);
    } catch (error) {
      console.error('Error cargando tarifas:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!editingTarifa) return;
    try {
      const id = editingTarifa.id || editingTarifa._id || editingTarifa.categoria;
      const updateData = {
        bajadabandera:        parseFloat(editingTarifa.bajadabandera)     || 0,
        ficha:                parseFloat(editingTarifa.ficha)             || 0,
        bajadabanderanoct:    parseFloat(editingTarifa.bajadabanderanoct) || 0,
        fichanoct:            parseFloat(editingTarifa.fichanoct)         || 0,
        horarioNocturnoInicio: editingTarifa.horarioNocturnoInicio || '22:00',
        horarioNocturnoFin:    editingTarifa.horarioNocturnoFin   || '05:00',
      };
      await api.put(`/tarifas/admin/${id}`, updateData);
      setTarifas(prev => prev.map(t => (t.id || t._id || t.categoria) === id ? { ...editingTarifa, ...updateData } : t));
      setEditingTarifa(null);
      setLastUpdate(new Date());
      alert('✅ Tarifa actualizada correctamente. Los cambios se aplicarán automáticamente a todos los usuarios.');
    } catch (error) {
      alert('❌ Error al actualizar tarifa: ' + error.message);
    }
  };

  const handleCreateNew = async () => {
    if (!newTarifa.categoria.trim()) { alert('Por favor ingrese el nombre de la categoría'); return; }
    try {
      const tarifaData = {
        categoria:            newTarifa.categoria.toLowerCase(),
        bajadabandera:        parseFloat(newTarifa.bajadabandera)     || 0,
        ficha:                parseFloat(newTarifa.ficha)             || 0,
        bajadabanderanoct:    parseFloat(newTarifa.bajadabanderanoct) || 0,
        fichanoct:            parseFloat(newTarifa.fichanoct)         || 0,
        horarioNocturnoInicio: newTarifa.horarioNocturnoInicio || '22:00',
        horarioNocturnoFin:    newTarifa.horarioNocturnoFin   || '05:00',
      };
      const created = await api.post('/tarifas', tarifaData);
      setTarifas(prev => [...prev, created.tarifa || { ...tarifaData, id: tarifaData.categoria }]);
      setNewTarifa({ categoria: '', bajadabandera: 0, ficha: 0, bajadabanderanoct: 0, fichanoct: 0, horarioNocturnoInicio: '22:00', horarioNocturnoFin: '05:00' });
      setShowNewForm(false);
      setLastUpdate(new Date());
      alert('✅ Nueva categoría de tarifa creada correctamente.');
    } catch (error) {
      alert('❌ Error al crear nueva tarifa: ' + error.message);
    }
  };

  const formatCurrency = (value) => new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 0 }).format(value);

  if (loading) return (
    <div className="section-loading"><div className="spinner"></div><p>Cargando configuración de tarifas...</p></div>
  );

  return (
    <div className="section-container">
      <div className="section-header">
        <h1>Configuración de Tarifas</h1>
        <p>Administre las tarifas por categoría. Los cambios se aplican automáticamente a todos los usuarios.</p>
        {lastUpdate && <div className="last-update">Última actualización: {lastUpdate.toLocaleString()}</div>}
      </div>

      <div className="section-actions">
        <button className="btn btn-primary" onClick={() => setShowNewForm(!showNewForm)}>
          {showNewForm ? 'Cancelar' : '+ Nueva Categoría'}
        </button>
      </div>

      {showNewForm && (
        <div className="new-tarifa-form">
          <div className="card">
            <div className="card-header"><h3>Crear Nueva Categoría de Tarifa</h3></div>
            <div className="card-body">
              <div className="form-row">
                <div className="form-group">
                  <label>Nombre de Categoría</label>
                  <input type="text" value={newTarifa.categoria} className="form-control"
                    placeholder="ej: taxi, remis, especial"
                    onChange={e => setNewTarifa(p => ({ ...p, categoria: e.target.value }))} />
                </div>
              </div>
              <div className="form-row">
                {[['bajadabandera','Bajada de Bandera (Día)'],['ficha','Valor Ficha (Día)']].map(([k,l]) => (
                  <div className="form-group" key={k}>
                    <label>{l}</label>
                    <input type="number" step="0.01" value={newTarifa[k]} className="form-control"
                      onChange={e => setNewTarifa(p => ({ ...p, [k]: e.target.value }))} />
                  </div>
                ))}
              </div>
              <div className="form-row">
                {[['bajadabanderanoct','Bajada de Bandera (Noche)'],['fichanoct','Valor Ficha (Noche)']].map(([k,l]) => (
                  <div className="form-group" key={k}>
                    <label>{l}</label>
                    <input type="number" step="0.01" value={newTarifa[k]} className="form-control"
                      onChange={e => setNewTarifa(p => ({ ...p, [k]: e.target.value }))} />
                  </div>
                ))}
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Horario Nocturno - Inicio</label>
                  <input type="time" value={newTarifa.horarioNocturnoInicio} className="form-control"
                    onChange={e => setNewTarifa(p => ({ ...p, horarioNocturnoInicio: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label>Horario Nocturno - Fin</label>
                  <input type="time" value={newTarifa.horarioNocturnoFin} className="form-control"
                    onChange={e => setNewTarifa(p => ({ ...p, horarioNocturnoFin: e.target.value }))} />
                </div>
              </div>
              <div className="form-actions">
                <button className="btn btn-primary"   onClick={handleCreateNew}>Crear Categoría</button>
                <button className="btn btn-secondary" onClick={() => setShowNewForm(false)}>Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr><th>Categoría</th><th>Bajada Bandera (Día)</th><th>Ficha (Día)</th><th>Bajada Bandera (Noche)</th><th>Ficha (Noche)</th><th>Horario Nocturno</th><th>Acciones</th></tr>
          </thead>
          <tbody>
            {tarifas.map(tarifa => (
              <tr key={tarifa.id || tarifa._id || tarifa.categoria}>
                <td><span className="category-badge">{tarifa.categoria?.toUpperCase() || 'N/A'}</span></td>
                <td><strong className="price">{formatCurrency(tarifa.bajadabandera || 0)}</strong></td>
                <td><strong className="price">{formatCurrency(tarifa.ficha || 0)}</strong></td>
                <td><strong className="price">{formatCurrency(tarifa.bajadabanderanoct || 0)}</strong></td>
                <td><strong className="price">{formatCurrency(tarifa.fichanoct || 0)}</strong></td>
                <td><span className="horario-display">{tarifa.horarioNocturnoInicio || '22:00'} - {tarifa.horarioNocturnoFin || '05:00'}</span></td>
                <td>
                  <div className="action-buttons">
                    <button className="btn btn-sm btn-primary" onClick={() => setEditingTarifa({ ...tarifa })}>Editar</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {tarifas.length === 0 && <div className="no-data"><p>No se encontraron tarifas configuradas</p></div>}
      </div>

      <div className="info-panel">
        <h4>ℹ️ Información Importante</h4>
        <ul>
          <li><strong>Propagación automática:</strong> Los cambios en las tarifas se aplican inmediatamente a todos los usuarios de la app.</li>
          <li><strong>Bajada de bandera:</strong> Importe que se cobra al inicio del viaje.</li>
          <li><strong>Ficha:</strong> Importe que se cobra cada 80 metros de distancia o cada minuto de espera.</li>
          <li><strong>Tarifas nocturnas:</strong> Se aplican automáticamente según el horario configurado.</li>
        </ul>
      </div>

      {editingTarifa && (
        <div className="modal-overlay">
          <div className="modal large">
            <div className="modal-header">
              <h3>Editar Tarifa - {editingTarifa.categoria?.toUpperCase()}</h3>
              <button className="modal-close" onClick={() => setEditingTarifa(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="alert alert-warning"><strong>⚠️ Atención:</strong> Los cambios se aplicarán automáticamente a todos los usuarios que usen esta categoría.</div>
              <div className="form-row">
                {[['bajadabandera','Bajada de Bandera (Día)','Importe inicial al comenzar el viaje durante el día'],
                  ['ficha','Valor Ficha (Día)','Importe por cada 80m de distancia o 1min de espera']].map(([k,l,s]) => (
                  <div className="form-group" key={k}>
                    <label>{l}</label>
                    <input type="number" step="0.01" value={editingTarifa[k] || 0} className="form-control"
                      onChange={e => setEditingTarifa(p => ({ ...p, [k]: e.target.value }))} />
                    <small>{s}</small>
                  </div>
                ))}
              </div>
              <div className="form-row">
                {[['bajadabanderanoct','Bajada de Bandera (Noche)','Importe inicial nocturno'],
                  ['fichanoct','Valor Ficha (Noche)','Importe nocturno por cada 80m o 1min']].map(([k,l,s]) => (
                  <div className="form-group" key={k}>
                    <label>{l}</label>
                    <input type="number" step="0.01" value={editingTarifa[k] || 0} className="form-control"
                      onChange={e => setEditingTarifa(p => ({ ...p, [k]: e.target.value }))} />
                    <small>{s}</small>
                  </div>
                ))}
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Horario Nocturno - Inicio</label>
                  <input type="time" value={editingTarifa.horarioNocturnoInicio || '22:00'} className="form-control"
                    onChange={e => setEditingTarifa(p => ({ ...p, horarioNocturnoInicio: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label>Horario Nocturno - Fin</label>
                  <input type="time" value={editingTarifa.horarioNocturnoFin || '05:00'} className="form-control"
                    onChange={e => setEditingTarifa(p => ({ ...p, horarioNocturnoFin: e.target.value }))} />
                </div>
              </div>
              <div className="preview-section">
                <h4>Vista Previa</h4>
                <div className="preview-grid">
                  <div className="preview-card">
                    <h5>Tarifa Diurna</h5>
                    <p>Bajada: <strong>{formatCurrency(editingTarifa.bajadabandera || 0)}</strong></p>
                    <p>Ficha: <strong>{formatCurrency(editingTarifa.ficha || 0)}</strong></p>
                  </div>
                  <div className="preview-card">
                    <h5>Tarifa Nocturna</h5>
                    <p>Bajada: <strong>{formatCurrency(editingTarifa.bajadabanderanoct || 0)}</strong></p>
                    <p>Ficha: <strong>{formatCurrency(editingTarifa.fichanoct || 0)}</strong></p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setEditingTarifa(null)}>Cancelar</button>
              <button className="btn btn-primary"   onClick={handleSave}>💾 Guardar y Aplicar Cambios</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TarifasSection;
